import {constants} from '@newsela/angelou';
import {css} from 'emotion';

import fonts from 'static/three-oh/src/modules/utils/fonts';

const suggestion = css`
  list-style-type: none;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  cursor: pointer;
  color: ${constants.colors.ui.greyDark['500']};
  font-size: ${fonts.sizes.m};

  &:focus {
    background: rgba(194, 219, 254, 0.29);
    outline: none;
    border-radius: 4px;
  }
`;

const textInOverlay = css`
  line-height: 48px;
  margin: 0;
  padding-left: 12px;
`;

export default {
  suggestion,
  textInOverlay,
};
